import { useQuery } from '@apollo/client';
import { string } from 'prop-types';
import React from 'react';

import Grid from '@material-ui/core/Grid';

import { HandleError } from 'components/Common/Error';
import Text from 'components/Common/Text';

import s from './LeagueRosterPlayerListHeaders.module.scss';
import { GET_CONTEST } from './queries';

export const LeagueRosterPlayerListHeaders = ({ contestId, currentWeek }) => {
  const { data, error, loading } = useQuery(GET_CONTEST, {
    variables: { id: contestId },
  });

  if (loading || !data) return null;
  if (error) {
    return <HandleError error={error.graphQLErrors[0]} fallback='Error getting contests. Please refresh the page.' />;
  }

  const weekRange = `Weeks ${data.contest.week.start} - ${data.contest.week.end} Season`;

  const sectionHeaders = (
    <Grid container xs={12} alignItems='center' className={s.sectionHeaders}>
        <Grid item xs={1}/>
        <Grid item xs={3}>
          <Text bold variant='body1'>
            Starters
          </Text>
        </Grid>
      <Grid container item xs={3}>
        <Text bold align='left' variant='body1'>
          Week {currentWeek} NFL
        </Text>
      </Grid>
      <Grid item xs={1}/>
      <Grid item xs={1}/>
      <Grid container item xs={3}>
        <Text bold align='left' variant='body1'>
          {weekRange}
        </Text>
      </Grid>
    </Grid>
  );

  return (
    <Grid container className={s.container}>
      {sectionHeaders}
      <Grid container xs={12} alignItems='center'>
      <Grid item xs={1}/>
      <Grid item xs={1}/>
        <Grid container item xs={5} justifyContent='space-between'>
          {/* <Grid container item justifyContent='center' xs={4}>
            <Text bold variant='body1'>
              OPRK
            </Text>
          </Grid> */}
          <Grid item xs={2}/>
          <Grid container item justifyContent='center' xs={5}>
            <Text bold variant='body1'>
              PROJ
            </Text>
          </Grid>
          <Grid container item justifyContent='center' xs={5}>
            <Text bold variant='body1'>
              SCORE
            </Text>
          </Grid>
        </Grid>
        <Grid container item xs={5} justifyContent='space-between'>
          {/* <Grid container item justifyContent='center' xs={4}>
            <Text bold variant='body1'>
              PRK
            </Text>
          </Grid> */}
          <Grid item xs={2}/>
          <Grid container item justifyContent='center' xs={5}>
            <Text bold variant='body1'>
              FPTS
            </Text>
          </Grid>
          <Grid container item justifyContent='center' xs={5}>
            <Text bold variant='body1'>
              AVG
            </Text>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LeagueRosterPlayerListHeaders;

LeagueRosterPlayerListHeaders.propTypes = {
  contestId: string,
};
